var Controller = require("common/Controller");
var SettingsListView = require("./SettingsListView");
var Utils = require("common/Utils");

function SettingsController() {
    Controller.call(this);
    const self = this;
    const listView = new SettingsListView();
    const views = [listView];

    this.getViews = function() {
        return views;
    };

    this.addDelegate = function(delegate) {
        const delegateViews = delegate.getViews();

        for (var i = 0; i < delegateViews.length; i++) {
            views.push(delegateViews[i]);
        }

        const delegateTopLevelViews = delegate.getTopLevelViews();

        for (var j = 0; j < delegateTopLevelViews.length; j++) {
            listView.addChildView(delegateTopLevelViews[j]);
        }

        const menuEntry = listView.addEntry(delegate.getLabel());

        delegate.setMenuEntry(menuEntry);

        delegate.setNavManager(CudaLaunch.navManager);
        CudaLaunch.navManager.registerController(delegate);
    };

    this.getId = function() {
        return "SettingsController";
    };

    this.showListView = function() {
        self.showView(listView);
    };
}

Utils.inherits(SettingsController, Controller);

module.exports = SettingsController;